import { useState, useEffect } from "react";
import Navbar from "./components/navbar/Navbar";
import Homepage from "./pages/homepage/Homepage";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import Settings from "./pages/settings/Settings";
import Single from "./pages/single/Single";
import Write from "./pages/write/Write";
import { Routes, Route } from "react-router-dom";
import { useAuthContext } from "./context/AuthContext";
import Profile from "./pages/profile/Profile";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import Sidebar from "./components/sidebar/Sidebar";

import axios from "axios";
import EditPost from "./pages/editpost/EditPost";
import Footer from "./components/footer/Footer";
import Articles from "./pages/articles/Articles";
import NotFound from "./pages/error/NotFound";
import ScrollToTop from "./helpers/ScrollToTop";

function App() {
  const { user } = useAuthContext();
  const [aboutBlog, setAboutBlog] = useState({});

  const [checked, setChecked] = useState(false);
  const [backendOk, setBackendOk] = useState(true); // new state

  useEffect(() => {
    async function checkBackendAndLoad() {
      try {
        const res = await axios.get(
          process.env.REACT_APP_API_URL +
            "/blog-infos?populate[main_photo]=true&populate[Logo]=true&populate[contact_photo]=true&populate[links]=true"
          // {
          //   headers: {
          //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
          //   },
          // }
        );
        // if (res.data.length > 0) {
        setAboutBlog(res.data.data[0]);
        setChecked(true);
        // }
      } catch (err) {
        setBackendOk(false);
        setChecked(true);
      }
    }

    checkBackendAndLoad();
  }, []);

  if (!checked) return null; // or loading spinner

  if (!backendOk) {
    return <NotFound />;
  }

  return (
    <>
      <ScrollToTop />
      <Navbar mainBlogData={aboutBlog} />
      <Routes>
        <Route path="/" element={<Homepage aboutBlog={aboutBlog} />} />
        <Route path="/posts" element={<Articles />} />

        <Route
          path="/register"
          element={user ? <Homepage aboutBlog={aboutBlog} /> : <Register />}
        />

        <Route
          path="/login"
          element={user ? <Homepage aboutBlog={aboutBlog} /> : <Login />}
        />
        <Route path="/profile" element={<Profile />} />
        <Route path="/post/:id" element={<Single />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact mainBlogData={aboutBlog} />} />
        <Route path="/write" element={user ? <Write /> : <Login />} />

        <Route path="/write/:postId" element={user ? <Write /> : <Login />} />

        <Route path="/settings" element={user ? <Settings /> : <Login />} />
        {/* <Route path="/edit/:id" element={<EditPost />} /> */}
        <Route path="/error" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer mainBlogData={aboutBlog} />
    </>
  );
}

export default App;
